// System
import Cookies from 'js-cookie';
import ReactDOM from 'react-dom/client';
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink } from '@apollo/client';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { useMemo } from 'react';
import { App } from './app/App';
import { RootContainer } from '@Components/root/RootContainer';
import { store, persistor } from './app/store';
import { StoreInterface } from './app/types';

export const ApolloProviderWithRgs = ({ children }: any) => {
  const rgs = useSelector((state: StoreInterface) => state.general.rgs) || 'EU';

  const client = useMemo(() => {
    const httpLink = createHttpLink({
      uri: process.env.REACT_APP_GRAPHQL_API_PROXY_URL,
    });

    const authLink = setContext((_, { headers }) => {
      const token = Cookies.get('accessToken');
      return {
        headers: {
          ...headers,
          'x-rgs-id': rgs,
          'x-game-id': '1',
          authorization: token ? `Bearer ${token}` : '',
        },
      };
    });

    return new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });
  }, [rgs]);
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

const jsx = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ApolloProviderWithRgs>
        <RootContainer>
          <App />
        </RootContainer>
      </ApolloProviderWithRgs>
    </PersistGate>
  </Provider>
);

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(jsx);
}
